import styled from "@emotion/styled"
import { yupResolver } from "@hookform/resolvers/yup"
import { ServiceOrderRequest, postContactUsCreateServiceRequest } from "api"
import { createRef, useEffect, useState } from "react"
import ReCAPTCHA from "react-google-recaptcha"
import { Controller, SubmitHandler, useForm } from "react-hook-form"
import { schemaCommon } from "reusable/Form/FormSchema"
import { trackLeadSubmit } from "reusable/gtm"
import { NewText, ReadMoreIcon, useIsDesktop } from "ui"
import GeneralErrorMsg from "ui/Errors/GeneralErrorMsg"
import { getSubjectId, getUtmParams } from "utils"
import * as yup from "yup"
import ContactUsState from "./ContactUsState"
import { StyledFiedlset, StyledLegend } from "./CustomerService"
import FormInput from "./FormInput"
import SubmitButton from "./SubmitButton"

const RECAPTCHA_KEY = process.env.RECAPTCHA_KEY
if (!RECAPTCHA_KEY) {
  throw new Error("Please provide the RECAPTCHA_KEY environment variable.")
}

const StyledDiv = styled.div`
`
const Asterisk = styled.span`
  color: blue;
  width: 4px;
`

const StyledTextWrapper = styled.div`
  display: flex;
  padding-top: 4px;
  align-items: center;
  p {
    margin-left: 8px;
  }

`
const StyledForm = styled.div`
  // padding-top: 24px;
  // ${(props) => props.theme.breakpoints.up("md")} {
  //   padding-top: 16px;
  // }
  // ${(props) => props.theme.breakpoints.up("lg")} {
  //   padding-top: 24px;
  // }
`

const StyledDivWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 1fr;
    gap: 21px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }
`

const CaptchaStyled = styled.div`
  visibility: hidden !important;
`

const StyledIDWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: calc(50% - 15px);
  }
`
const StyledFooterForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  ${(props) => props.theme.breakpoints.up("md")} {
    flex-direction: row;
    align-items: center;
    gap: 0px;
    justify-content: space-between;
    padding-top: 10px;
  }
     ${(props) => props.theme.breakpoints.only("md")} {
          p{
            font-size: 12px;
            }

            span{
              font-size: 12px;
            }

  }
`

const schema = yup.object({
  firstName: schemaCommon.firstName,
  lastName: schemaCommon.lastName,
  ID: schemaCommon.ID,
  email: schemaCommon.email,
  phoneNumber: schemaCommon.phoneNumber,
  description: schemaCommon.description,
  comments: schemaCommon.comments,
})

interface IFormInputs {
  firstName: string
  lastName: string
  ID: string
  email: string
  phoneNumber: string
  description: string
  comments: string
}

function PazomatService() {
  const isDesktop = useIsDesktop()
  const [isSuccess, setIsSuccess] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const reCaptchaRef = createRef<ReCAPTCHA>()
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset
  } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      ID: "",
      email: "",
      phoneNumber: "",
      description: "",
      comments: "",
    },
    shouldFocusError: true,
    resolver: yupResolver(schema),
  })

  const onSubmit: SubmitHandler<IFormInputs> = async (data) => {
    reCaptchaRef?.current?.reset()
    const recaptchaResponse =
      (await reCaptchaRef?.current?.executeAsync()) as string

    const postData: ServiceOrderRequest = {
      FirstName: data.firstName,
      LastName: data.lastName,
      MobilePhone: data.phoneNumber,
      Email: data.email,
      SubjectId: getSubjectId("אחר - פזומט"),
      Message: data.description + " " + data.comments,
      IsFromYellowBox: false,
      CustomerId: data.ID,
      City: "",
      CustomerTypeId: "",
      PlatformUserId: "",
      GRecaptchaResponse: recaptchaResponse,
      ...getUtmParams(),
      Source: "10",
    }
    try {
      const response = (await postContactUsCreateServiceRequest(
        "",
        postData,
      )) as any
      if (response?.data?.Body && !response.data.errorCode) {
        setIsSuccess(true)
        trackLeadSubmit("פזומט", data?.description)
        reset()
      } else {
        setIsSuccess(false)
      }
    } catch (error) {
      setIsSuccess(false)
    } finally {
      setIsOpen(true)
    }
  }
  useEffect(() => {
    const firstErrorKey = Object.keys(errors).find((key) => key in errors) as
      | keyof IFormInputs
      | undefined

    if (firstErrorKey) {
      const errorElement = document.querySelector(
        `input[name="${firstErrorKey}"]`,
      ) as HTMLInputElement | null

      errorElement?.focus()
    }
  }, [errors])
  return (
    <>
      <StyledDiv>
        <StyledForm>
          <form onSubmit={handleSubmit(onSubmit)}>
            <StyledFiedlset>
              <StyledLegend>טופס פזומט</StyledLegend>
              <StyledDivWrapper>
                <Controller
                  name="firstName"
                  control={control}
                  render={({ field }) => (
                    <FormInput
                      field={field}
                      error={errors.firstName?.message}
                      placeholder="שם פרטי"
                      type="text"
                      required={true}
                    />
                  )}
                />
                <Controller
                  name="lastName"
                  control={control}
                  render={({ field }) => (
                    <FormInput
                      field={field}
                      error={errors.lastName?.message}
                      placeholder="שם משפחה"
                      type="text"
                      required={true}
                    />
                  )}
                />
              </StyledDivWrapper>

              <StyledDivWrapper>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) => (
                    <FormInput
                      field={field}
                      error={errors.email?.message}
                      placeholder="אימייל"
                      type="text"
                      required={true}
                    />
                  )}
                />
                <Controller
                  name="phoneNumber"
                  control={control}
                  render={({ field }) => (
                    <FormInput
                      field={field}
                      error={errors.phoneNumber?.message}
                      placeholder="טלפון"
                      type="number"
                      required={true}
                    />
                  )}
                />
              </StyledDivWrapper>
              <StyledIDWrapper>
                <Controller
                  name="ID"
                  control={control}
                  render={({ field }) => (
                    <FormInput
                      field={field}
                      error={errors.ID?.message}
                      placeholder="ת.ז / ח.פ"
                      type="number"
                      required={true}
                    />
                  )}
                />
              </StyledIDWrapper>
              <Controller
                name="description"
                control={control}
                render={({ field }) => (
                  <FormInput
                    field={field}
                    error={errors.description?.message}
                    placeholder={
                      isDesktop ? "באיזה נושא נוכל לסייע לך?" : "נושא הפנייה"
                    }
                    type="text"
                    fullWidth
                    required={true}
                  />
                )}
              />
              <Controller
                name="comments"
                control={control}
                render={({ field }) => (
                  <FormInput
                    field={field}
                    error={errors.comments?.message}
                    placeholder={
                      isDesktop ? "יש לך שאלה או בקשה?" : "איך אפשר לעזור?"
                    }
                    type="text"
                    fullWidth
                  />
                )}
              />
              {Object.keys(errors).length > 0 && (
                <GeneralErrorMsg error={"אחד או יותר מהשדות בטופס אינם תקינים"} />
              )}
            </StyledFiedlset>
            <StyledFooterForm>
              <StyledTextWrapper>
                <Asterisk>*</Asterisk>
                <NewText
                  component={"p"}
                  largeDesktopFontSize={16}
                  largeDesktopLineHeight={"24px"}
                  desktopFontWeight={400}
                  desktopFontSize={16}
                  desktopLineHeight="24px"
                >
                  שדות המסומנים הם שדות חובה
                </NewText>
              </StyledTextWrapper>
              <SubmitButton>
                <span>שליחה</span>
                <ReadMoreIcon color="white" />
              </SubmitButton>
            </StyledFooterForm>
            <CaptchaStyled>
              {RECAPTCHA_KEY && (
                <ReCAPTCHA
                  ref={reCaptchaRef}
                  sitekey={RECAPTCHA_KEY}
                  size="invisible"
                  hl="iw"
                  tabIndex={-1}
                />
              )}
            </CaptchaStyled>
          </form>
        </StyledForm>
        <ContactUsState
          isOpen={isOpen}
          isSuccess={isSuccess}
          setIsOpen={setIsOpen}
        />
      </StyledDiv >
    </>
  )
}

export default PazomatService
